import {
  RangePicker,
  DateRangeFilter,
  defaultQueryParamKeys,
} from '@cast/shared-date-ui';

import {
  dashboardChartFilterPresets,
  DASHBOARD_RANGE_PICKER_SX,
  DASHBOARD_CHART_MAX_DAYS,
} from '../constants/dashboardCharts';

export const DashboardChartRangePicker = () => (
  <RangePicker
    queryParamKeys={defaultQueryParamKeys}
    filterPresets={dashboardChartFilterPresets}
    initialPreset={DateRangeFilter.Last30Days}
    maxNumberOfDays={DASHBOARD_CHART_MAX_DAYS}
    triggerInputProps={{ size: 'small' }}
    sx={DASHBOARD_RANGE_PICKER_SX}
  />
);
